import React from 'react';
import { FaPalette, FaRulerCombined, FaBox, FaTshirt, FaMoneyBillWave, FaMobileAlt } from 'react-icons/fa';
import IndustryPageTemplate from './IndustryPageTemplate';

const featureIcons = {
  1: <FaPalette />,
  2: <FaRulerCombined />,
  3: <FaBox />,
  4: <FaTshirt />,
  5: <FaMoneyBillWave />,
  6: <FaMobileAlt />
};

const TextileIndustryPage = () => {
  return (
    <IndustryPageTemplate 
      industryKey="textile"
      gradient="#fa709a 0%, #fee140 100%"
      emoji=""
      featureIcons={featureIcons}
    />
  );
};

export default TextileIndustryPage;

